import { locale, languages } from "bizfly-ui";
import Cookies from "js-cookie";
import en from "../lang/en.json";
import vi from "../lang/vi.json";

const langCode = Cookies.get("bfc_language") || "vi";
locale(languages[langCode]);

const VueI18n = require("vue-i18n").default;
window.Vue = require("vue").default;

const i18n = new VueI18n({
  locale: langCode,
  fallbackLocale: "vi",
  messages: {
    en,
    vi,
  },
});

export { i18n };
